import React from 'react';

export default (props) => {
  let cls = 'warning';

  if (props.entry.published) {
    if (props.entry.updated) {
      cls = 'info';
    } else {
      cls = 'success';
    }
  } else if (props.entry.archived) {
    cls = 'danger';
  }

  const rowProps = Object.assign({}, props, {
    className: `${props.className || ''} ${cls}`
  });

  // Remove the entry prop before passing to tr:
  delete rowProps.entry;

  return (
    <tr {...rowProps} />
  );
};
